import { TableHeadersType } from "../tableHeadersType";

export const GOVERMENT_DIRECTORY_HEADERS: TableHeadersType[] = [
  {
    label: "NAME",
    value: "name",
  },
  {
    label: "EMAIL",
    value: "email",
  },
  {
    label: "JOB TITLE",
    value: "job_title",
  },
  {
    label: "USER BRANCH",
    value: "branch_name",
  },
  {
    label: "MAPPED JOBS",
    value: "mapped_jobs",
  },
];

export const VIEW_MAPPED_JOBS_HEADERS: TableHeadersType[] = [
  {
    "label": "Job Type",
    "value": "job_type",
    "defaultChecked": true,
    "checked": true,
  },
  {
    "label": "Client Details",
    "value": "name",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Target End Date",
    "value": "target_end_date",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Currently Responsible",
    "value": "currently_responsible",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Job Manager",
    "value": "job_manager",
    "defaultChecked": true,
    "checked": true
  },

  {
    "label": "Details",
    "value": "job_details",
    "defaultChecked": true,
    "checked": true
  },

  {
    "label": "Status",
    "value": "current_job_state",
    "defaultChecked": true,
    "checked": true
  },

];
